import { Box, Button, Grid, IconButton, Snackbar, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR1, COLOR5, CONTINUE, SAVEYOURAPPLICATION, TYPE_OF_ACCOUNT } from '../../constants';
import LeadGenerationContext from '../../context/LeadGenerationContext';
// import BookmarkIcon from '../../images/BookmarkIcon.png';

import BookmarkIconDisable from '../../images/disableiconsavebtn.svg';
import { commonTernary, getRoot, isBundle, isCDproduct, isWebComponentFlow } from '../commonCode';
import { LayoutStyles as LayoutClasses } from './LayoutStyles';
import { CommonStyles } from '../LeadGeneration/CommonStyles';
import LineStepper from './Stepper';
import Loader from '../Loader/Loader';
import { businessMapping } from '../../services/businessMapping';
import { BookmarkIcon, SaveAndContinue, SnackBarInfo } from '../../images/svg/CustomizedSVG';
import Footer from '../Footer/Footer';
import SnackbarCloseIcon from '../../images/Close.svg';
import { ReturnToSavedApplicationStyles as snackClasses } from '../SaveAndContinue/ReturnToSavedApplicationStyles';
import SimpleTextModal from '../Modal/SimpleTextModal';
import SaveandcontinueTextModal from './SaveandcontinueTextModal';

const NewLayout = (props) => {
  const {
    children,
    consent,
    continueBtnTestid,
    saveApplicationTestId,
    handleBack,
    handleSaveApplication,
    handleContinue,
    screenLoading,
    disableCondition,
    stepValue,
    isValidating,
  } = props;
  const baseContext = isWebComponentFlow();
  const {
    currentPage,
    isApplicationSaved,
    savedDataFlow,
    disableContinue,
    setStep,
    productName,
    flowTypeETB,
    termsAndConditionPreSignedURL,
    theme,
    userSavedPage,
    continueModal,
    complianceData,
    productData,
    isLightTheme,
  } = baseContext;

  const styledClasses = CommonStyles(theme);
  const themes = useTheme();
  const isMobile = useMediaQuery(themes?.breakpoints?.down('600'), {
    defaultMatches: true,
  });

  const { t } = useTranslation();
  const totalSteps = 8;
  const [snackbarstate, setSnackbarstate] = useState(false);
  const [resizePaddingTop, setResizePaddingTop] = useState('');

  const handleClose = () => {
    setSnackbarstate(false);
  };
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const element = getRoot().querySelector('[data-page]');
    if (element) {
      setResizePaddingTop(element.style.paddingTop);
      if (
        element.getAttribute('data-page') === userSavedPage &&
        query.get('returnTopage') === userSavedPage
      ) {
        setSnackbarstate(true);
      }
    }
  }, [complianceData, productData]);
  useEffect(() => {
    const element = getRoot().querySelector('[data-page]');
    if (element) {
      if (snackbarstate) {
        element.style.paddingTop = '105px';
      } else {
        element.style.paddingTop = resizePaddingTop;
      }
    }
  }, [snackbarstate, complianceData, productData]);
  const getPage = () => {
    let returnPage;
    if (userSavedPage === 'address-info' || userSavedPage === 'personal-info') {
      returnPage = true;
    } else {
      returnPage = false;
    }
    return returnPage;
  };
  const onContinue = (e) => {
    e.preventDefault();
    setStep((prev) => Math.min(prev + 1, totalSteps - 1));
    if (handleContinue) handleContinue(e);
  };

  const onBack = (e) => {
    setStep((prev) => Math.max(prev - 1, 0));
    if (handleBack) handleBack(e);
  };

  return (
    <>
      <Grid
        container
        sx={{
          ...LayoutClasses.mainContainer,
          background: theme?.customBackground,
          color: theme?.palette?.primary?.main,
          minHeight: '100vh',
        }}
      >
        <Grid container size={{ xs: 12 }} flexDirection="column" justifyContent="space-between">
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid
              container
              sx={{
                ...LayoutClasses.container,
                justifyContent: 'center',
                alignItems: 'center',
                ...(baseContext?.wcFlow && LayoutClasses.wccontainer),
              }}
            >
              {currentPage !== 'contact-info' && (
                <Grid item xs={12} style={{ width: '100%' }}>
                  <LineStepper handleBack={onBack} totalSteps={totalSteps} stepValue={stepValue} />
                </Grid>
              )}

              {/* <Grid item xs={12} style={{ width: '100%' }}> */}
              <Grid
                size={{ xs: 12, md: 8, sm: 8 }}
                style={{ position: 'relative', width: '100%' }}
                sx={{
                  ...styledClasses.snackBarMobile,
                  '@media (max-width: 600px)': {
                    minHeight: 'calc(100vh - 305px)',
                  },
                  '@media (max-width: 450px)': {
                    margin: '0',
                  },
                }}
              >
                {snackbarstate && (
                  <Snackbar
                    id="snackbarId"
                    data-testid="snackbar_testid"
                    open={snackbarstate}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    sx={
                      getPage()
                        ? snackClasses.snackbarPositionMobile
                        : snackClasses.snackbarPosition
                    }
                    style={snackClasses.snackbarReturnRootBundle}
                    // onClose={handleClose}
                    slotProps={{
                      content: {
                        sx: {
                          ...snackClasses.snackbarRetunStyleViaContentPropsBundle,
                          left: 0,
                          background: isLightTheme
                            ? '#F5E9F5'
                            : `linear-gradient(190.14deg, #661C69 -3.38%, #170618 47.43%, #2E0B2F 108.34%),
                     linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))`,
                          border: isLightTheme ? '2px solid #661C69' : '2px solid #F5821F',
                        },
                        style: { minWidth: 'auto' },
                      },
                    }}
                    action={
                      <IconButton
                        id="closeIconId"
                        style={{ position: 'absolute', right: '16px', top: '6px' }}
                        size="small"
                        color={COLOR1}
                        onClick={handleClose}
                        data-testid="snackbarclose_testid"
                      >
                        <img
                          id="closeImgId"
                          src={SnackbarCloseIcon}
                          height="16px"
                          width="16px"
                          alt={t('close')}
                        />
                      </IconButton>
                    }
                    message={
                      <Box component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box display="flex" alignItems="center">
                          <IconButton
                            classes={{ sizeSmall: snackClasses.snackBarBtn }}
                            size="small"
                            color={COLOR5}
                            sx={{ padding: 0, marginRight: '8px' }}
                          >
                            <SnackBarInfo color={theme?.palette?.orientalPrimary?.main} />
                          </IconButton>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              ...snackClasses.snackbarMessageBundle,
                              color: theme?.palette?.primary?.main,
                            }}
                          >
                            {t('Recovered Application', { defaultValue: 'Recovered Application' })}
                          </Typography>
                        </Box>

                        <Box
                          component="div"
                          sx={{
                            ...snackClasses.snackbarMessagesubtext,
                            color: isLightTheme ? '#000' : theme?.palette?.subtext?.main,
                          }}
                        >
                          {t('Continue your application process where you left off!', {
                            defaultValue: 'Continue your application process where you left off!',
                          })}
                        </Box>
                      </Box>
                    }
                  />
                )}
                {children}
              </Grid>

              <Grid
                container
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px',
                  marginTop: '30px',
                  width: '100%',
                  flexWrap: 'nowrap',
                  '@media (max-width:600px)': {
                    // flexWrap: 'wrap',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    borderRadius: '20px',
                    background: theme?.customBackground,
                    boxShadow: '0 0 0 10px transparent',
                    gap: '12px',
                  },
                }}
              >
                {!isApplicationSaved &&
                flowTypeETB !== 'EtbFlow' &&
                !savedDataFlow &&
                currentPage !== 'contact-info' ? (
                  // <Grid
                  //   item
                  //   sx={[styledClasses.mobileButtons, styledClasses.backBtnGrid, { width: '100%' }]}
                  // >
                  <Button
                    disableFocusRipple
                    disabled={
                      currentPage === 'address-info' || currentPage === 'business-comp'
                        ? disableContinue
                        : false
                    }
                    onClick={handleSaveApplication}
                    data-testid={saveApplicationTestId}
                    sx={
                      isMobile
                        ? styledClasses.mobileSaveApplicationButtonBundle
                        : (currentPage === 'address-info' || currentPage === 'business-comp') &&
                          disableContinue
                        ? styledClasses.saveApplicationButtonDIS
                        : styledClasses.saveApplicationButtonBundle
                    }
                  >
                    {isMobile ? (
                      <Box
                        sx={{
                          ...styledClasses.saveApplicationButtonBundle1,
                          padding: '0px',
                        }}
                      >
                        <BookmarkIcon color={theme?.palette?.orientalPrimary?.main} />
                      </Box>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {(currentPage === 'address-info' || currentPage === 'business-comp') &&
                        disableContinue ? (
                          <img src={BookmarkIconDisable} alt="blub" />
                        ) : (
                          <BookmarkIcon color={theme?.palette?.orientalPrimary?.main} />
                        )}
                        <span style={{ marginLeft: '10px' }}>
                          {t(SAVEYOURAPPLICATION, { defaultValue: SAVEYOURAPPLICATION })}
                        </span>
                      </div>
                    )}
                  </Button>
                ) : (
                  flowTypeETB !== 'EtbFlow' &&
                  currentPage !== 'contact-info' && (
                    // </Grid>
                    <IconButton
                      disableFocusRipple
                      // disabled={
                      //   (currentPage === 'address-info' || currentPage === 'business-comp') &&
                      //   disableContinue
                      // }
                      aria-label="saved icon"
                      sx={{
                        pointerEvents: 'none',
                        '@media (max-width: 600px)': {
                          padding: '0px',
                          minWidth: '48px',
                        },
                        '&:focus': {
                          border: '1px solid #000',
                          padding: '5px',
                          borderRadius: '3px',
                        },
                      }}
                      onClick={handleSaveApplication}
                      data-testid={saveApplicationTestId}
                    >
                      <SaveAndContinue color={theme?.palette?.orientalPrimary?.main} />
                    </IconButton>
                  )
                )}

                <Grid
                  item
                  sx={[
                    styledClasses.mobileButtons,
                    styledClasses.ContinueBtnGrid,
                    { width: '100%' },
                  ]}
                >
                  <Button
                    disableFocusRipple
                    onClick={onContinue}
                    disabled={disableCondition}
                    data-testid={continueBtnTestid}
                    variant="subtitle1"
                    sx={{
                      height: '48px',
                      padding: '14px 50px',
                      gap: '10px',
                      borderRadius: '56px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      whiteSpace: 'nowrap',

                      '&.Mui-disabled': {
                        ...(currentPage === 'personal-info-consumer'
                          ? styledClasses.next_disabled_button
                          : (isApplicationSaved || savedDataFlow) && !consent
                          ? {
                              ...styledClasses.save_disabled_button,
                              ...(savedDataFlow ? { width: '100% !important' } : {}),
                            }
                          : {
                              ...styledClasses.disabled_button_bundle,
                              ...(savedDataFlow ? { width: '100%' } : {}),
                            }),
                      },

                      ...(currentPage === 'personal-info-consumer'
                        ? styledClasses.next_continue_button
                        : (isApplicationSaved || savedDataFlow) && !consent
                        ? {
                            ...styledClasses.save_continue_button,
                            width: '100%',
                            ...(savedDataFlow
                              ? { width: '100%' }
                              : {
                                  '@media (max-width: 600px)': {
                                    marginBottom: '0px',
                                  },
                                }),
                          }
                        : {
                            ...styledClasses.continue_button,
                            width: '100% !important',
                            height: '48px !important',
                            '@media (max-width: 600px)': {
                              marginBottom: '0px',
                            },
                          }),
                    }}
                  >
                    {currentPage === 'personal-info-consumer'
                      ? t('Next: Address info', {
                          defaultValue: 'Next: Address info',
                          nsSeparator: '|',
                        })
                      : currentPage === 'document-checklist' &&
                        !savedDataFlow &&
                        !businessMapping(productName)
                      ? t('Next', {
                          defaultValue: 'Next',
                          nsSeparator: '|',
                        })
                      : t(
                          isCDproduct(productName) &&
                            consent &&
                            termsAndConditionPreSignedURL !== ''
                            ? 'Agree & Submit'
                            : (consent || currentPage === 'upload-documents-later') &&
                              !isBundle(productName)
                            ? 'Submit'
                            : (consent || currentPage === 'upload-documents-later') &&
                              isBundle(productName)
                            ? 'bundleConsentSubmit'
                            : commonTernary(
                                (isApplicationSaved || savedDataFlow) && !isBundle(productName),
                                'Save & Continue',
                                CONTINUE
                              ),
                          {
                            defaultValue:
                              isCDproduct(productName) &&
                              consent &&
                              termsAndConditionPreSignedURL !== ''
                                ? 'Agree & Submit'
                                : consent || currentPage === 'upload-documents-later'
                                ? 'Submit'
                                : commonTernary(
                                    (isApplicationSaved || savedDataFlow) && !isBundle(productName),
                                    'Save & Continue',
                                    CONTINUE
                                  ),
                          }
                        )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            size={{ sx: 12 }}
            sx={{
              paddingTop: '40px',
              '@media(max-width: 600px)': {
                paddingTop: '0px',
              },
            }}
          >
            {!baseContext?.wcFlow &&
            currentPage !== 'vouched' &&
            currentPage !== 'camera-upload' ? (
              <Footer />
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </Grid>
      {!consent && screenLoading && (
        <div className="loader-style">
          <Loader />
        </div>
      )}
      {isValidating && (
        <div className="loader-saveApp-style">
          <Loader />
        </div>
      )}
      {continueModal && <SaveandcontinueTextModal />}
    </>
  );
};

export default NewLayout;

NewLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  consent: PropTypes.bool,
  continueBtnTestid: PropTypes.string,
  saveApplicationTestId: PropTypes.string,
  handleBack: PropTypes.func,
  handleSaveApplication: PropTypes.func,
  handleContinue: PropTypes.func,
  screenLoading: PropTypes.bool,
  disableCondition: PropTypes.bool,
  isValidating: PropTypes.bool,
  stepValue: PropTypes.number,
};
